import * as React from "react";
import {
  HeroImageSection,
  FeaturedTrailersSection,
  ServicesSection,
  HowItWorksSection,
  AboutOurTeamSection,
  ContactUsFormSection,
} from "../components";

export const HomeView = () => (
  <>
    <HeroImageSection />
    <FeaturedTrailersSection />
    <ServicesSection />
    <HowItWorksSection />
    <AboutOurTeamSection />
    <ContactUsFormSection />
  </>
);
